import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlugInTerminal = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 436,
	height: 241,
	viewBox: "0 0 436 241",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M393.607 24.9881L29.6348 24.988C26.4375 24.988 23.732 27.3503 23.3009 30.5183L20.8077 48.8381C20.6151 50.2533 20.6241 51.6886 20.8345 53.1012L21.1797 55.4193L21.6873 56.8997C24.667 65.5901 32.8391 71.4272 42.0262 71.4272L281.597 71.4272C282.251 71.4272 282.886 71.648 283.399 72.0538L307.636 91.2219C314.853 96.9301 324.313 98.9618 333.238 96.7206L395.804 81.0094C400.467 79.8384 403.61 75.48 403.249 70.6855L400.27 31.1686C400.008 27.6825 397.103 24.9881 393.607 24.9881Z",
			fill: "#CED3DA",
			stroke: "#6F7780",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.2487 55.3566L301.224 55.3566C334.774 55.3566 368.275 52.7979 401.435 47.7029V47.7029",
			stroke: "#6F7780",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 301.737,
			cy: 44.3034,
			rx: 5.61507,
			ry: 5.61507,
			transform: "rotate(90 301.737 44.3034)",
			fill: "#9EC5FF",
			stroke: "#146EF5",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 301.737,
			cy: 44.3037,
			rx: 1.36709,
			ry: 1.36709,
			transform: "rotate(90 301.737 44.3037)",
			stroke: "#146EF5",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M126.223 44.197C126.775 44.197 127.223 44.6447 127.223 45.197L127.223 45.914C127.223 46.6139 126.978 47.2917 126.531 47.8302L125.798 48.7132C125.228 49.3998 124.382 49.797 123.49 49.797L111.418 49.797C110.525 49.797 109.679 49.3998 109.109 48.7132L108.376 47.8302C107.929 47.2917 107.685 46.6139 107.685 45.914L107.685 45.197C107.685 44.6447 108.132 44.197 108.685 44.197L126.223 44.197Z",
			stroke: "#6F7780",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M313.289 46.5663L309.716 43.7552C309.643 43.698 309.699 43.5821 309.789 43.6036L312.511 44.2569L312.262 42.5123C312.206 42.1254 312.654 41.8707 312.958 42.1156L316.674 45.102C316.747 45.1611 316.686 45.2785 316.595 45.2518L313.846 44.4432L313.985 46.1935C314.015 46.568 313.585 46.7987 313.289 46.5663Z",
			fill: "#146EF5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M225.14 54.3566C225.14 54.9089 225.588 55.3566 226.14 55.3566L265.442 55.3566C266.078 55.3566 266.553 54.77 266.42 54.1477L266.094 52.6235C264.715 46.1642 259.008 41.5479 252.403 41.5479L226.14 41.5479C225.588 41.5479 225.14 41.9956 225.14 42.5479L225.14 54.3566Z",
			fill: "#CED3DA",
			stroke: "#6F7780",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M221.815 41.5479C222.368 41.5479 222.815 41.9956 222.815 42.5479L222.815 54.3566C222.815 54.9089 222.368 55.3566 221.815 55.3566L188.252 55.3566C187.61 55.3566 187.135 54.761 187.277 54.1353L187.659 52.4501C189.106 46.0737 194.774 41.5479 201.312 41.5479L221.815 41.5479Z",
			fill: "#CED3DA",
			stroke: "#6F7780",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M213.5 89C213.5 88.1716 212.828 87.5 212 87.5C211.171 87.5 210.5 88.1716 210.5 89L213.5 89ZM210.939 117.061C211.525 117.646 212.474 117.646 213.06 117.061L222.606 107.515C223.192 106.929 223.192 105.979 222.606 105.393C222.02 104.808 221.071 104.808 220.485 105.393L212 113.879L203.514 105.393C202.928 104.808 201.979 104.808 201.393 105.393C200.807 105.979 200.807 106.929 201.393 107.515L210.939 117.061ZM210.5 89L210.5 116L213.5 116L213.5 89L210.5 89Z",
			fill: "#146EF5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.3661 158.347C25.0089 189.436 28.3188 201.156 35.1983 233.621C35.9835 237.327 39.254 240 43.0421 240H104.864C108.656 240 111.926 237.339 112.697 233.627L119.568 200.547C121.147 192.944 127.958 187.572 135.72 187.809L288.494 192.456C296.053 192.686 302.419 198.178 303.756 205.621L308.746 233.414C309.431 237.226 312.748 240 316.62 240H404.792C408.685 240 412.012 237.198 412.675 233.363L434.217 108.733C435.062 103.843 431.297 99.3705 426.334 99.3705H425.137C422.439 99.3705 419.923 100.73 418.445 102.986L413.565 110.434C412.273 112.405 410.198 113.703 407.854 113.949C398.335 114.947 371.099 117.468 335.329 117.903C302.589 118.301 274.81 117.826 262.232 117.542C258.131 117.449 254.62 120.45 254.076 124.516L253.775 126.77C253.244 130.743 249.854 133.71 245.846 133.71H173.552C169.66 133.71 166.332 130.908 165.669 127.072L165.232 124.541C164.569 120.705 161.241 117.903 157.349 117.903H151.664C147.669 117.903 144.286 120.85 143.739 124.808L143.463 126.806C142.916 130.763 139.534 133.71 135.539 133.71H119.374C114.955 133.71 111.374 130.129 111.374 125.71V125.068C111.374 120.764 107.969 117.232 103.669 117.073L18.6271 113.93C13.3482 113.735 9.33282 118.619 10.5451 123.761L11.0931 126.085C11.9258 129.616 15.0309 132.145 18.6579 132.246L59.7633 133.385C65.2919 133.538 68.8404 139.322 66.4726 144.32C65.2055 146.995 62.5107 148.7 59.5511 148.7H26.1719C21.096 148.7 17.3055 153.383 18.3661 158.347Z",
			fill: "#CED3DA",
			stroke: "#6F7780",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.4333 156.32C245.296 164.165 426.537 156.32 426.537 156.32",
			stroke: "#6F7780",
			strokeWidth: 2
		})
	]
});
export default SvgPlugInTerminal;
